import type { CardDetailProps } from "./CardDetail.d";
import { CardDetail } from "./CardDetail";

export { CardDetailProps, CardDetail };
